import { render, staticRenderFns } from "./ShowImageProviderPreview.vue?vue&type=template&id=08d391b2&scoped=true&"
import script from "./ShowImageProviderPreview.vue?vue&type=script&lang=ts&"
export * from "./ShowImageProviderPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ShowImageProviderPreview.vue?vue&type=style&index=0&id=08d391b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d391b2",
  null
  
)

export default component.exports